var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#comment_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 10.666V14a2 2 0 0 1-2 2h-3.333a5.332 5.332 0 0 1-4.614-2.666 7.308 7.308 0 0 0 1.495-.166 3.991 3.991 0 0 0 3.119 1.5H14a.666.666 0 0 0 .667-.668v-3.333a3.992 3.992 0 0 0-1.502-3.119c.108-.49.164-.992.168-1.494A5.333 5.333 0 0 1 16 10.666Zm-4.015-4.233A6.001 6.001 0 0 0 5.566.015 6.279 6.279 0 0 0 0 6.195v3.36C0 11.243 1.005 12 2 12h3.8a6.28 6.28 0 0 0 6.185-5.566ZM9.3 2.7a4.679 4.679 0 0 1 1.355 3.64A4.91 4.91 0 0 1 5.8 10.666H2c-.619 0-.667-.85-.667-1.11v-3.36A4.908 4.908 0 0 1 5.66 1.344 4.675 4.675 0 0 1 9.3 2.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "comment_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgComment;